import axios from 'axios';
import { getApiBaseUrl } from '../config/apiConfig';

// Public API client không cần authentication
const publicApiClient = axios.create({
  baseURL: getApiBaseUrl(),
  timeout: 30000, // Tăng timeout lên 30 giây
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor để log requests
publicApiClient.interceptors.request.use(
  (config) => {
    if (process.env.NODE_ENV === 'development') {
      console.log('Public API Request:', {
        method: config.method?.toUpperCase(),
        url: config.url,
        baseURL: config.baseURL,
        fullURL: `${config.baseURL}${config.url}`,
        data: config.data,
        headers: config.headers
      });
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor để xử lý lỗi chung
publicApiClient.interceptors.response.use(
  (response) => {
    if (process.env.NODE_ENV === 'development') {
      console.log('Public API Response:', {
        status: response.status,
        url: response.config.url,
        data: response.data
      });
    }
    return response;
  },
  (error) => {
    // Log detailed error information
    if (error.response) {
      console.error('Public API Error Response:', {
        status: error.response.status,
        statusText: error.response.statusText,
        url: error.config?.url,
        baseURL: error.config?.baseURL,
        data: error.response.data,
        headers: error.response.headers
      });
    } else if (error.request) {
      console.error('Public API Error - No Response:', {
        url: error.config?.url,
        baseURL: error.config?.baseURL,
        message: error.message
      });
    } else {
      console.error('Public API Error:', error.message);
    }
    return Promise.reject(error);
  }
);

export default publicApiClient;
